import { CommonHttp } from "@/models/interfaces/http/common.http.request";

export type VersionOut = {
    Global: number,
    Component: number,
    Update: number,
    Fix: number,
}

export type VersionGiver = {
    ServerVersion: VersionOut,
    ClientVersion: VersionOut,
    ClientRefreshRequired: boolean,
}

export class VersionApi {
    // Получение записанных версий сервера и клиента
    static getVersions(): Promise<VersionGiver | undefined> {
        const http = new CommonHttp()
        return http
            .get('versions')
            .then(data => data?.data)
    }
}
